<template>
  <el-table-column
    prop="representative_user_name"
    sortable="custom"
    label="Képviselő"
  >
    <template slot-scope="scope">
      {{ scope.row.representative_user_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'representativeUser.last_name',
  };
</script>
